/**
 * Empty string = same origin (browser talks to whatever host serves the page — merged FE+BE).
 * For `npm run dev` (Vite on :5173) with API on :3000, set VITE_API_URL in .env.development.
 */
export const API_URL = import.meta.env.VITE_API_URL ?? '';
